const KEYBOARD_KEYS = {
  left: "ArrowLeft",
  right: "ArrowRight",
  escape: "Escape"
} as const

const DEFAULT_BEHAVIOR = {
  wrapNavigation: true,
  showThumbnails: true,
  showProgress: true,
  showShareButton: true,
  showDownloadButton: true
} as const

const ARIA_LABELS = {
  modal: "Image gallery",
  close: "Close gallery",
  prev: "Previous image",
  next: "Next image",
  download: "Download image",
  share: "Share image",
  regenerate: "Regenerate image",
  regenerateDifferent: "Regenerate with different prompt",
  thumbnail: (index: number, total: number) => `View image ${index + 1} of ${total}`,
  progressDot: (index: number) => `Go to image ${index + 1}`,
  image: (index: number, total: number) => `Gallery image ${index + 1} of ${total}`
}

const LAYOUT = {
  thumbnailStripWidth: 56,
  thumbnailSize: 36,
  controlButtonSize: 32,
  imageMaxHeight: "90vh",
  closeControlRightOffset: 8,
  downloadControlRightOffset: 52,
  shareControlRightOffset: 92
} as const

export { KEYBOARD_KEYS, DEFAULT_BEHAVIOR, ARIA_LABELS, LAYOUT }
